import { LocalizationContextImplementation } from './localization-context-implementation';
import { DEFAULT_I18N_DOMAIN } from "./localization-context";
/**
 * Builder class for {@link LocalizationContextImplementation}.
 */
//TODO: Use options object instead of builder.
export class LocalizationContextBuilder {
    constructor() {
        this._locale = LocalizationContextBuilder.DEFAULT_LOCALE;
        this._defaultLocale = undefined;
        this._timeZone = LocalizationContextBuilder.DEFAULT_TIME_ZONE;
        this._i18nDomain = DEFAULT_I18N_DOMAIN;
    }
    /**
     * Gets locale. Default value is OS locale.
     */
    get locale() {
        return this._locale;
    }
    /**
     * Gets default locale. Default value is undefined.
     */
    get defaultLocale() {
        return this._defaultLocale;
    }
    /**
     * Gets timeZone. Default value is set to local time zone.
     */
    get timeZone() {
        return this._timeZone;
    }
    /**
     * Gets i18nDomain. Default value is empty string.
     */
    get i18nDomain() {
        return this._i18nDomain;
    }
    /**
     * Sets locale on context.
     * @param locale
     * @returns a reference to this object with locale set
     */
    withLocale(locale) {
        try {
            // @ts-ignore
            this._locale = Intl.getCanonicalLocales(locale)[0];
        }
        catch (error) {
            console.error(`Provided Locale is invalid: locale=${locale}. Using default runtime locale: ${LocalizationContextBuilder.DEFAULT_LOCALE}`);
        }
        return this;
    }
    /**
     * Sets default locale.
     * @param defaultLocale
     * @returns a reference to this object with default locale set
     */
    withDefaultLocale(defaultLocale) {
        try {
            // @ts-ignore
            this._defaultLocale = Intl.getCanonicalLocales(defaultLocale)[0];
        }
        catch (error) {
            console.error(`Provided DefaultLocale is invalid: defaultLocale:${defaultLocale}.`);
        }
        return this;
    }
    /**
     * Sets i18nDomain.
     * @param i18nDomain
     * @returns a reference to this object with i18nDomain set
     */
    withI18nDomain(domain) {
        this._i18nDomain = domain;
        return this;
    }
    /**
     * Sets timeZone. TimeZone plain string is validated using Intl.
     * @param timeZone
     * @returns a reference to this object with timeZone set
     */
    withTimeZone(timeZone) {
        try {
            const dateTimeFormat = new Intl.DateTimeFormat(undefined, { timeZone });
            this._timeZone = dateTimeFormat.resolvedOptions().timeZone;
        }
        catch (error) {
            console.error(`Provided TimeZone is invalid: timeZone=${timeZone}. Using default TimeZone: ${LocalizationContextBuilder.DEFAULT_TIME_ZONE}`);
        }
        return this;
    }
    /**
     * Builds localization context.
     * @returns LocalizationContextImplementation
     */
    build() {
        return new LocalizationContextImplementation(this);
    }
}
LocalizationContextBuilder.DATE_TIME_OPTIONS = new Intl.DateTimeFormat().resolvedOptions();
LocalizationContextBuilder.DEFAULT_LOCALE = LocalizationContextBuilder.DATE_TIME_OPTIONS.locale;
LocalizationContextBuilder.DEFAULT_TIME_ZONE = LocalizationContextBuilder.DATE_TIME_OPTIONS.timeZone;
//# sourceMappingURL=data:application/json;base64,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